import { Fragment } from 'react';

import {
  List,
  Paper,
  Divider,
  ListItemButton,
  Typography,
} from '@mui/material';
import { Box, BoxProps } from '@mui/system';
import { useItems } from '@scorenco/components';
import { RouteLink, Types, useTranslation } from '@scorenco/core';

type CompetitionListProps = BoxProps & {
  category: string;
  levels?: Types.Competitions_Level_For_Season_Detail[];
};

export const CompetitionList = ({
  category,
  levels,
  ...rest
}: CompetitionListProps) => {
  const { t } = useTranslation();
  const items = useItems(levels, 5);

  const title =
    category.split(' ')[0] + ' ' + t(`${category.slice(-1)}_GENDER`);

  return (
    <Box key={category} {...rest}>
      <Typography
        variant="h5"
        sx={{ textTransform: 'uppercase', fontStyle: 'unset', mb: 2 }}
      >
        {title}
      </Typography>

      <Paper variant="bordered" sx={{ padding: 0, alignItems: 'stretch' }}>
        <List disablePadding>
          {items.map((level, idx) => (
            <Fragment key={level?.id || idx}>
              {idx !== 0 && <Divider />}
              <ListItemButton component={RouteLink} href={level?.url}>
                {level?.name}
              </ListItemButton>
            </Fragment>
          ))}
        </List>
      </Paper>
    </Box>
  );
};
